import React from "react";
import { UserAdminForm } from "./components/UserAdminForm";

export function UserAdminInfomation() {
  return (
    <>
      <nav aria-label="breadcrumb" className="mt-2 mb-4">
        <ol className="breadcrumb fs-16 ps-0">
          <li className="breadcrumb-item ">
            <a href="#/" className="tc-7  text-decoration-none">
              ลูกค้า{" "}
            </a>
          </li>
          <li className="breadcrumb-item active tc-1 " aria-current="page">
            {" "}
            ข้อมูลลูกค้า{" "}
          </li>
        </ol>
      </nav>

      <div className="text-2xl tc-7   mb-4 lh-1">ข้อมูลลูกค้า </div>

      <UserAdminForm />
    </>
  );
}
